import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { FuseqService } from '../fuseq.service'
import { FuseqSessionService } from '../session.service'

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const fuseqService = inject(FuseqService)
  const fuseqUser = inject(FuseqSessionService)

  const currentUser = fuseqUser.session
  if (currentUser?.token) {
    req = req.clone({
      setHeaders: {
        Authorization: fuseqService.getBackEndAuthentication(),
        AuthToken: currentUser.token,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    })
  }
  return next(req)
}
